module.exports = __webpack_public_path__ + "img/badge_giftcard.a929d6e5.jpg";